import { PARSE_FILES_ACTIONS } from "./actionTypes";
export const ParseFilesSelectors = {
  upload: state => state.parseFiles[PARSE_FILES_ACTIONS.UPLOAD]
};